
export function formatCurrency(
  amount: number | undefined,
  currency: string = "GBP"
): string {
  if (amount === undefined) return "-";
  
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(
  dateString: string | undefined,
  options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" }
): string {
  if (!dateString) return "-";
  
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("en-US", options).format(date);
}

export function formatPercentage(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

/**
 * Formats a byte value to a human readable format
 * @param bytes - The number of bytes
 * @param decimals - The number of decimal places (default: 2)
 * @returns Formatted string (e.g. "1.5 KB", "2.4 MB")
 */
export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Formats currency specifically for GBP with proper pound symbol
 * @param amount - The amount to format
 * @returns Formatted string with £ symbol
 */
export const formatGBP = (amount: number | undefined): string => {
  if (amount === undefined || amount === null) return "-";
  
  console.log('formatGBP called with amount:', amount);
  
  const formatted = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  
  console.log('formatGBP result:', formatted);
  return formatted;
};
